import CARCS_JSON from './json/CARCS.json'

export const CARCS: Array<{
  code: string
  description: string
  label: string
  phase?: string[]
  outcome?: string[]
  reason?: string[]
  occurrences?: number
}> = CARCS_JSON
